import React from 'react';
import { Grid, Loader } from 'semantic-ui/semantic-ui-imports';
import { InputRow, ResultSet } from 'services/results';
import { DefaultValueEntity } from 'Types/Aggregates';
import './index.scss';

interface Props {
  data: ResultSet | undefined;
}

function Calulations({ data }: Props) {
  if (!data) {
    return <Loader />;
  }

  const gridGroup = (group: any, key: string) => (
    <React.Fragment key={key}>
      <Grid.GridRow className="calculations__subheader">
        <h3>{group.title}</h3>
      </Grid.GridRow>
      {group.values
        .filter((val: DefaultValueEntity) => val && val.name)
        .map((val: DefaultValueEntity) => (
          <React.Fragment key={val.name}>
            <Grid.GridRow>
              <Grid.GridColumn
                className="calculations__max-column-width"
                width={7}
              >
                <p>{val.name}</p>
              </Grid.GridColumn>
              <Grid.GridColumn width={3} textAlign="right">
                <p dangerouslySetInnerHTML={{ __html: val.value }}></p>
              </Grid.GridColumn>
              <Grid.GridColumn width={6}>
                <p>{val.description}</p>
              </Grid.GridColumn>
            </Grid.GridRow>
          </React.Fragment>
        ))}
    </React.Fragment>
  );

  const filterClass = (val: InputRow, idx: number) => (
    <Grid.GridRow className="calculations__filterclass" key={`${idx}`}>
      <Grid.GridRow>
        <h4>{val.title}:</h4>
      </Grid.GridRow>
      <Grid.GridRow className="calculations__filterclass--row">
        <Grid.GridColumn width={2}>
          <p dangerouslySetInnerHTML={{ __html: val.values[0] }}></p>
        </Grid.GridColumn>
        <Grid.GridColumn width={2}>
          <p dangerouslySetInnerHTML={{ __html: val.values[1] }}></p>
        </Grid.GridColumn>
      </Grid.GridRow>
      <Grid.GridRow className="calculations__filterclass--row">
        <Grid.GridColumn>
          <p dangerouslySetInnerHTML={{ __html: val.values[2] }}></p>
        </Grid.GridColumn>
        <Grid.GridColumn>
          <p dangerouslySetInnerHTML={{ __html: val.values[3] }}></p>
        </Grid.GridColumn>
      </Grid.GridRow>
    </Grid.GridRow>
  );

  const temperaturePrereq = (val: InputRow, idx: number) => (
    <Grid.GridRow className="calculations__temperature" key={`${idx}`}>
      <Grid.GridRow>
        <h4>{val.title}:</h4>
      </Grid.GridRow>
      <Grid.GridRow>
        <Grid.GridColumn width={2}>
          <p>{val.values[0]}</p>
        </Grid.GridColumn>
        <Grid.GridColumn width={2}>
          <p>{val.values[1]}</p>
        </Grid.GridColumn>
        <Grid.GridColumn width={4}>
          <p>{val.values[2]}</p>
        </Grid.GridColumn>
      </Grid.GridRow>
      <Grid.GridRow>
        <Grid.GridColumn width={2}></Grid.GridColumn>
        <Grid.GridColumn width={2}>
          <p>{val.values[3]}</p>
        </Grid.GridColumn>
        <Grid.GridColumn width={4}>
          <p>{val.values[4]}</p>
        </Grid.GridColumn>
      </Grid.GridRow>

      <Grid.GridRow>
        <Grid.GridColumn width={2}>
          <p>{val.values[5]}</p>
        </Grid.GridColumn>
        <Grid.GridColumn width={2}>
          <p>{val.values[6]}</p>
        </Grid.GridColumn>
        <Grid.GridColumn width={4}>
          <p>{val.values[7]}</p>
        </Grid.GridColumn>
      </Grid.GridRow>
      <Grid.GridRow>
        <Grid.GridColumn width={2}></Grid.GridColumn>
        <Grid.GridColumn width={2}>
          <p>{val.values[8]}</p>
        </Grid.GridColumn>
        <Grid.GridColumn width={4}>
          <p>{val.values[9]}</p>
        </Grid.GridColumn>
      </Grid.GridRow>
    </Grid.GridRow>
  );

  const airVolumes = (val: InputRow, idx: number) => (
    <Grid.GridRow key={`${idx}`}>
      <Grid.GridRow>
        <h4>{val.title}:</h4>
      </Grid.GridRow>
      <Grid.GridRow>
        <Grid.GridColumn width={16}>
          <p>{val.values[0]}</p>
        </Grid.GridColumn>
      </Grid.GridRow>
      <Grid.Row>
        <Grid.GridColumn width={16}>
          <p>{val.values[1]}</p>
        </Grid.GridColumn>
      </Grid.Row>
    </Grid.GridRow>
  );

  return (
    <div className="calculations">
      <Grid>
        <Grid.GridRow>
          <h2 className="calculations__header">{data.calculations.title}</h2>
        </Grid.GridRow>
        <Grid.GridRow className="calculations__subheader">
          <h3>{data.calculations.inputs.title}</h3>
        </Grid.GridRow>
        <Grid.GridRow>
          <p>{data.calculations.inputs.description}</p>
        </Grid.GridRow>

        <div className="calculations__fluid">
          {data.calculations.inputs.values.map((val: InputRow, idx: number) => {
            if (val.key === 'airVolumes') {
              return airVolumes(val, idx);
            }
            if (val.key === 'filterBox') {
              return filterClass(val, idx);
            }
            return <></>;
          })}
        </div>
        <div className="calculations__fluid">
          {data.calculations.inputs.values.map((val: InputRow, idx: number) => {
            if (val.key === 'temperaturePrereq') {
              return temperaturePrereq(val, idx);
            }
            return <></>;
          })}
        </div>
        {data.calculations?.electricity &&
          gridGroup(data.calculations.electricity, 'electricity')}
        {data.calculations?.heating &&
          gridGroup(data.calculations.heating, 'heating')}
        {data.calculations?.cooling &&
          gridGroup(data.calculations.cooling, 'cooling')}
      </Grid>
    </div>
  );
}

export default Calulations;
